import { SizableText, SmartLink, Stack, YStack, useMedia } from '@my/ui'
import { SolitoImage } from 'solito/image'
import { OpenGraphDataProxyQueryOutput } from './queries'

export interface LinkPreviewProps {
  url: string
  loading: boolean
  openGraphData?: OpenGraphDataProxyQueryOutput
}

export const LinkPreview = (props: LinkPreviewProps) => {
  const media = useMedia()
  // If we're loading then we don't want to show anything
  if (props.loading) {
    return null
  }

  // If we have no preview data then we can't load a preview
  if (!props.openGraphData) {
    return null
  }

  // If we have no title then we probably shouldn't load a preview
  if (!props.openGraphData.title) {
    return null
  }

  return (
    <SmartLink
      Component={YStack}
      href={props.url}
      gap="$3"
      p="$3.5"
      bc="$gray2"
      br="$3"
      $gtXs={{
        gap: '$3.5',
        fd: 'row',
      }}
      hoverStyle={{
        opacity: 0.85,
      }}
      focusStyle={{
        opacity: 0.8,
      }}
      pressStyle={{
        opacity: 0.85,
      }}
    >
      {props.openGraphData?.image && (
        <Stack
          overflow="hidden"
          br="$3"
          aspectRatio={16 / 9}
          flexShrink={1}
          $gtXs={{
            flexBasis: 192,
            minWidth: 100,
          }}
        >
          <SolitoImage
            src={props.openGraphData?.image}
            alt={props.openGraphData?.title || ''}
            contentFit="cover"
            fill
            unoptimized
          />
        </Stack>
      )}
      <YStack justifyContent="center" gap="$1" flex={1} mr="$4">
        <SizableText
          size="$4"
          fow="600"
          textOverflow="ellipsis"
          numberOfLines={media.gtXs ? 1 : 2}
          color="$black"
        >
          {props.openGraphData.title}
        </SizableText>
        <SizableText size="$2" color="$gray11" numberOfLines={1}>
          {props.url}
        </SizableText>
      </YStack>
    </SmartLink>
  )
}
